import React, { useState, useEffect, useRef } from 'react';
import { useFormik, yupToFormErrors } from 'formik';
import * as Yup from 'yup';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { useDispatch } from 'react-redux';
import { handlePostRequest } from '../../services/PostTemplate';
import { handleGetRequest } from '../../services/GetTemplate';
import Loader from '../../components/loader';
import { Dropdown } from 'primereact/dropdown';
import { toast } from 'react-toastify';
import QRCode from 'qrcode.react';

function RenewRoutePermit({ onHideSidebar, rowData, fetchPermitsData }) {
    const [loading, setLoading] = useState(false);
    const [feeData, setFeeData] = useState([]);
    const [gracePeriod, setGracePeriod] = useState(0);
    const [finePerMonth, setFinePerMonth] = useState(0); // Changed from finePerDay to finePerMonth
    const [routesList, setRoutesList] = useState(``)
     const [paymentMethod, setPaymenytMetod] = useState();

    const dispatch = useDispatch();

    useEffect(() => {
        const getFeeData = async () => {
            try {
                const response = await handleGetRequest(`/api/permit/fee/${rowData?.vehicleTypeId}`, false);
                if (response?.success && rowData) {
                    setFeeData(response.data);
                }
            } catch (error) {
                console.error(error);
            }
        };
        getFeeData();
    }, [rowData]);


    useEffect(() => {
        if (feeData?.length) {
        calculateFeeAndFine();
        }
    }, [feeData])

    const calculateFeeAndFine = () => {
    const renewalFee = feeData[0]?.renewalFee || 0;
    const finePerMonth = feeData[0]?.finePerMonth || 0;
    
    setFinePerMonth(finePerMonth);

    const expiryDate = new Date(rowData.expDate);
    const today = new Date();
    
    // Set both dates to start of day to avoid time differences affecting calculation
    expiryDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    
    
    // Check if permit has expired
    if (expiryDate < today) {
        // Calculate months more accurately using year and month differences
        let yearDiff = today.getFullYear() - expiryDate.getFullYear();
        let monthDiff = today.getMonth() - expiryDate.getMonth();
        
        // Calculate total months difference
        let overdueMonths = yearDiff * 12 + monthDiff;
        
        // Adjust for day of month (if today's day is earlier in month than expiry date's day)
        if (today.getDate() < expiryDate.getDate()) {
            overdueMonths--;
        }
        
        // Ensure overdueMonths is at least 1 if expired (can't be negative or zero if expired)
        overdueMonths = Math.max(1, overdueMonths);
        
        
        const fineAmount = finePerMonth * overdueMonths;
        const totalAmount = renewalFee + fineAmount;
        
        
        formik.setFieldValue('renewalFee', renewalFee);
        formik.setFieldValue('fineAmount', fineAmount);
        formik.setFieldValue('totalAmount', totalAmount);
    } else {
        // Not expired yet, only set renewal fee
        formik.setFieldValue('renewalFee', renewalFee);
        formik.setFieldValue('fineAmount', 0);
        formik.setFieldValue('totalAmount', renewalFee);
    }
};
    const formik = useFormik({
        initialValues: {
            permitNumber: rowData?.permitNum || '',
            vehicleTypeName: rowData?.vehicleType || '',
            expirationDate: rowData?.expDate || null,
            routeNumber: rowData?.routeNumber,
            // updatedRoute: '',
            renewalFee: 0,
            fineAmount: 0,
            totalAmount: 0,
            mobileNumber: rowData?.mobileNumber,
            paymentMethod: ''
        },
        validationSchema: Yup.object().shape({
            permitNumber: Yup.string().required('Permit Number is required'),
            renewalFee: Yup.number().required('Renewal fee is required').min(0, 'Cannot be negative'),
            fineAmount: Yup.number().min(0, 'Cannot be negative'),
            totalAmount: Yup.number().required('Total amount is required').min(0, 'Cannot be negative'),
            mobileNumber: Yup.string().required('Mobile Number is required').matches(/^\d+$/, 'Mobile Number must be numeric'),
            paymentMethod:Yup.string().required('Payment Method is required')
        }),
        enableReinitialize: true,
        onSubmit: async (values) => {
            try {
                setLoading(true);
                const payload = {
                    permitNumber: values.permitNumber,
                    fitnessCFX: rowData?.fitnessCFX || '',
                    mobileNumber: rowData?.mobileNumber || '',
                    registerationNumber: rowData?.regNum || '',
                    registerationFee: values.renewalFee,
                    fineAmount: values.fineAmount,
                    totalAmount: values.totalAmount,
                    routeNumber: values?.routeNumber,
                };
                var res = await dispatch(handlePostRequest(payload, '/api/permit/renew', false, false));
                if (res?.success === true) {
                    const responseId = res?.data?.requestId;
                    if (formik.values.paymentMethod === '0') {
                        const response = await handleGetRequest(`/api/permit/DQR/${responseId}`, true);
                        if (response?.success === true) {
                            
                            setPaymenytMetod(response?.data);
                        }
                    } else {
                        fetchPermitsData();
                        onHideSidebar();
                    }
                    toast.success(res?.message || 'Permit renewed successfully')
                }
                if (res?.success === false) {
                    toast.error(res?.message || 'Failed to renew permit');
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }
    });

    const handleClose = () => {
        fetchPermitsData();
        onHideSidebar();
    };

    const isFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFieldError = (name) => isFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;

    useEffect(() => {
        const newTotal = (formik.values.renewalFee || 0) + (formik.values.fineAmount || 0);
        formik.setFieldValue('totalAmount', newTotal);
    }, [formik.values.renewalFee, formik.values.fineAmount]);

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const getRoutes = async () => {
        const response = await handleGetRequest('/api/dropdown/routes', false);
        if (response?.success === true) {
            setRoutesList(response?.data)
            // if (response?.data?.length > 0) {
            //     const filteredValue = response?.data?.filter((item) => {
            //         if (item?.name === rowData?.routeNumber) {
            //             formik.setFieldValue('updatedRoute', item?.id);
            //         }
            //     })
            // }
        }
    }

    useEffect(() => {
        getRoutes()
    }, [])

   
    
    const methodLov = [
        {
            label: 'Cash Payment',
            value: '1'
        },
        {
            label: 'Online Payment',
            value: '0'
        }
    ];

    return (
        <>
            <div className="sidebar-header">
                <div className="header-content">
                    <h2>Renew Permit</h2>
                    <Button icon="pi pi-times" onClick={onHideSidebar} className="p-button-rounded p-button-danger p-button-text p-button-sm" style={{ fontSize: '1rem' }} />
                </div>
            </div>
            {!paymentMethod && (
                <>
                    <div className="p-4" style={{ 
                        height: 'calc(100vh - 70px)', 
                        overflowX: 'hidden', 
                        width: '100%',
                        boxSizing: 'border-box'
                    }}>
                        <form onSubmit={formik.handleSubmit} className="h-full flex flex-column">
                            <div className="flex-grow-1" style={{ 
                                paddingBottom: '60px', 
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                width: '100%'
                            }}>
                                <div className="form-group mb-3">
                                    <label className="form-label mb-2">Permit Number</label>
                                    <InputText id="permitNumber" name="permitNumber" disabled value={formik.values.permitNumber} onChange={formik.handleChange} className={isFieldValid('permitNumber') ? 'p-invalid w-full' : 'w-full'} />
                                    {getFieldError('permitNumber')}
                                </div>

                                <div className="form-group mb-3">
                                    <label className="form-label mb-2">Vehicle Category</label>
                                    <InputText id="vehicleTypeName" name="vehicleTypeName" disabled value={formik.values.vehicleTypeName} onChange={formik.handleChange} className="w-full" />
                                </div>
                                <div className="form-group mb-3">
                                    <label className="form-label mb-2">Mobile Number</label>
                                    <InputText id="mobileNumber" name="mobileNumber" maxLength={11} minLength={11} value={formik.values.mobileNumber} onChange={formik.handleChange} className="w-full" />
                                </div>
                                <div className="form-group mb-3">
                                    <label className="form-label mb-2">Route Number</label>
                                    <InputText id="routeNumber" name="routeNumber" disabled value={formik.values.routeNumber} onChange={formik.handleChange} className="w-full" />
                                </div>

                                {/* <div className="form-group mb-3">
                                    <label className="form-label mb-2">Updated Route</label>
                                    <Dropdown
                                        options={routesList}
                                        placeholder="Please select route"
                                        optionValue="id"
                                        optionLabel="name"
                                        id="updatedRoute"
                                        name="updatedRoute"
                                        value={formik.values.updatedRoute}
                                        onChange={formik.handleChange}
                                        className="Dropdown__Round"
                                    />
                                </div> */}

                                <div className="form-group mb-3">
                                    <label className="form-label mb-2">Last Expiry Date</label>
                                    <InputText disabled id="expirationDate" name="expirationDate" value={formik.values.expirationDate} onChange={formik.handleChange} className="w-full" />
                                </div>

                                <div className="form-group mb-3">
                                    <label className="form-label mb-2">Renewal Fee</label>
                                    <InputNumber
                                        id="renewalFee"
                                        name="renewalFee"
                                        value={formik.values.renewalFee}
                                        onValueChange={(e) => formik.setFieldValue('renewalFee', e.value)}
                                        mode="currency"
                                        currency="PKR"
                                        locale="en-US"
                                        className={isFieldValid('renewalFee') ? 'p-invalid w-full' : 'w-full'}
                                        disabled
                                    />
                                    {getFieldError('renewalFee')}
                                </div>

                                <div className="form-group mb-3">
                                    <label className="form-label mb-2">Fine Amount</label>
                                    <InputNumber
                                        id="fineAmount"
                                        name="fineAmount"
                                        value={formik.values.fineAmount}
                                        onValueChange={(e) => formik.setFieldValue('fineAmount', e.value)}
                                        mode="currency"
                                        currency="PKR"
                                        locale="en-US"
                                        className={isFieldValid('fineAmount') ? 'p-invalid w-full' : 'w-full'}
                                        disabled
                                    />
                                    {getFieldError('fineAmount')}
                                </div>

                                <div className="form-group mb-3">
                                    <label className="form-label mb-2">Total Amount</label>
                                    <InputNumber
                                        id="totalAmount"
                                        name="totalAmount"
                                        value={formik.values.totalAmount}
                                        mode="currency"
                                        currency="PKR"
                                        locale="en-US"
                                        className={isFieldValid('totalAmount') ? 'p-invalid w-full bg-gray-100' : 'w-full bg-gray-100'}
                                        disabled
                                    />
                                    {getFieldError('totalAmount')}
                                </div>
                                <div className="form-group mb-3">
                                    <label className="form-label mb-2">Payment Method</label>
                                    <Dropdown
                                        options={methodLov}
                                        optionValue="value"
                                        optionLabel="label"
                                        id="paymentMethod"
                                        name="paymentMethod"
                                        value={formik.values.paymentMethod}
                                        onChange={formik.handleChange}
                                        placeholder="Choose payment method"
                                        className="Dropdown__Round"
                                    />
                                    {getFieldError('paymentMethod')}
                                </div>
                            </div>
                            <div className="form-group mt-2 p-1">
                                <p style={{ color: 'red', fontWeight: 500, textAlign: 'center' }}>        {`After Route Expiry date, a fine of PKR ${finePerMonth} will be applied for each month or part thereof.`}</p>
                            </div>
                            <div className="mt-3 pt-3 border-top-1 border-300" style={{ position: 'sticky', bottom: '20px', background: 'white', display: 'flex', justifyContent: 'center' }}>
                                <Button type="submit" label={loading ? 'Please wait...' : 'Renew Permit'} className="Btn__Dark" style={{ width: '150px' }} disabled={loading} />
                            </div>
                        </form>
                    </div>
                </>
            )}
            {paymentMethod && (
                <>
                    <div style={{ display: 'flex', justifyContent: 'center', margin: '1rem' }}>
                        <QRCode value={paymentMethod?.qrString} size={256} />
                    </div>
                    <p style={{ color: 'red', fontWeight: 500, textAlign: 'center' }}>{`Use QR Code for the payment or use consumer id: ${paymentMethod?.consumerId}`}</p>
                    <div className="mt-3 pt-3 border-top-1 border-300" style={{ position: 'sticky', bottom: '20px', background: 'white', display: 'flex', justifyContent: 'center' }}>
                        <Button label="Close" className="Btn__Dark" style={{ width: '150px' }} onClick={handleClose} />
                    </div>
                </>
            )}

            {loading && <Loader />}
        </>
    );
}

export default RenewRoutePermit;